<template>
  <div>
    <slot v-if="hasSlot()" name="clickable" :busy='isSharing' :share='share'>

    </slot>
    <p v-else>Share</p>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      text: String,
      url: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        stopTimeout: undefined,
        isSharing: false

      }
    },
    methods: {
      internalOnSuccess() {
        this.isSharing = false;
        this.$emit('success');
        this.$ana.track({
          eventCategory:'share',
          eventAction:'main-success',
          extra:{
            url:this.url,
          }
        });
      },
      internalOnTimeout() {
        this.isSharing = false;
        this.$emit('timeout');
      },
      internalOnError(message) {
        //alert("le share: " + message);
        this.isSharing = false;
        const id = this.id
        this.isSharing = false;

        if (message === 'Share canceled' || (message||{}).indexOf('canceled') > 0) {
          return;
        }
        if (message !== "method not supported") {
          this.$emit('error', message); 
          this.$ana.track({
            eventCategory:'share',
            eventAction:'main-error',
            extra:{
              url:this.url,
              message
            }
          });
          return;
        }
        const dummy = document.createElement('input'),
            text = this.url;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

        this.$ana.track({
          eventCategory:'share',
          eventAction:'main-copy',
          extra:{
            url:this.url
          }
        });
        this.$emit('copied');
      },
      hasSlot() {
        return true;
        return !!this.$slots['clickable']
      },
      share() {
        console.log('start the sharing');
        this.isSharing = true;
        const data = {
          title: this.title,
          text: this.text,
          url: this.url
        };
        this.stopTimeout = setTimeout( () => {
          this.internalOnTimeout("timeout");
        }, 15 * 1000);
        if (navigator.share) {
          navigator.share(data)
            .then((succ) => {
              clearTimeout(this.stopTimeout);
              this.internalOnSuccess(succ);
            })
            .catch((err) => {
              clearTimeout(this.stopTimeout);
              this.internalOnError(err);
            })
        } else {
          clearTimeout(this.stopTimeout);
          this.internalOnError('method not supported');
        }
      }
    }
  }
</script>
